import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUser, faCalendarDays, faListCheck, faPen, faBoxArchive, faTrash, faRotateLeft,
} from '@fortawesome/free-solid-svg-icons';

const formatDate = (ts) => {
  if (!ts) return '—';
  const d = new Date(ts);
  if (isNaN(d)) return '—';
  return `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}.${d.getFullYear()}`;
};

const OrderCard = ({ order, status, onEdit, onArchive, onUnarchive, onDelete, isArchive }) => {
  const statusObj = status?.find(s => s._id === order.status);
  const statusName = statusObj?.name || '—';
  const statusColor = statusObj?.color || '#7c3aed';
  const isOverdue = order.deadline && !isArchive && new Date(order.deadline) < new Date();

  return (
    <div className={`order-card ${isOverdue ? 'order-card--overdue' : ''}`}>
      <div className="order-card__header">
        <div className="order-card__number">№ {order.number || '—'}</div>
        <span
          className="order-card__status"
          style={{
            background: `${statusColor}22`,
            color: statusColor,
            borderColor: `${statusColor}55`,
          }}
        >
          {statusName}
        </span>
      </div>

      <div className="order-card__for">
        <FontAwesomeIcon icon={faUser} />
        <span>{order.forWhom || 'Не указано'}</span>
      </div>

      <div className="order-card__meta">
        <span className="order-card__meta-item">
          <FontAwesomeIcon icon={faListCheck} />
          {order.items?.length || 0} поз.
        </span>
        <span className="order-card__meta-item">
          <FontAwesomeIcon icon={faCalendarDays} />
          {formatDate(order.deadline)}
        </span>
      </div>

      <div className="order-card__footer">
        <span className="order-card__creator">{order.creatorName || '—'}</span>
        <span className="order-card__created">{formatDate(order.createdAt)}</span>
      </div>

      <div className="order-card__actions">
        {!isArchive && (
          <>
            <button className="order-action order-action--edit" onClick={() => onEdit(order)} title="Редактировать">
              <FontAwesomeIcon icon={faPen} />
            </button>
            <button className="order-action order-action--archive" onClick={() => onArchive(order)} title="В архив">
              <FontAwesomeIcon icon={faBoxArchive} />
            </button>
          </>
        )}
        {isArchive && (
          <button className="order-action order-action--restore" onClick={() => onUnarchive(order)} title="Из архива">
            <FontAwesomeIcon icon={faRotateLeft} />
          </button>
        )}
        <button className="order-action order-action--delete" onClick={() => onDelete(order)} title="Удалить">
          <FontAwesomeIcon icon={faTrash} />
        </button>
      </div>
    </div>
  );
};

export default OrderCard;